import React, { useState } from 'react';
import styles from './CartonMeasurement.module.scss';
import { useTranslation } from 'react-i18next';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { CartonData } from '@/types/CartonData.type';
import { DecimalInput } from '@/components/DecimalInput';
import AddButton from '@/components/AddButton';
import { CardComponent } from '@/components/CardComponent/CardComponent';
import { isCartonNumberInvalid } from '@/utils/validation/cartonValidation';



export const CartonMeasurement: React.FC<DynamicComponentProps> = (props: DynamicComponentProps) => {
    const { t: translate } = useTranslation();
    const [touchedCartonNumber, setTouchedCartonNumber] = useState<Record<number, boolean>>({});


    const { inspection, cartonDataChangeHandlers } = props;


    const updateCarton = (index: number, key: keyof CartonData, value: number | string | null) => {
        const updated = { ...inspection.cartonData?.[index], [key]: value } as CartonData;
        cartonDataChangeHandlers?.onEdit?.(updated, index);
    };

    const handleChange = (index: number, key: keyof CartonData) => (value: number | string | null) => {
        updateCarton(index, key, value);
    };

    const addCarton = () => {
        cartonDataChangeHandlers?.onAdd?.();
    }

    const removeCarton = (index: number) => {
        // setCartons((prev) => prev.filter((_, i) => i !== index));
        cartonDataChangeHandlers?.onDelete?.(index);
    };

    return (
        <CardComponent {...props} >
            <div className={styles.tableWrap}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>{translate('Carton #')}</th>
                            <th>{translate('Length')}</th>
                            <th>{translate('Width')}</th>
                            <th>{translate('Height')}</th>
                            <th>{translate('Weight')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {inspection.cartonData?.map((c, idx) => (
                            <tr key={`${c.id || idx}`}>
                                <td data-label={translate('Carton #')}>
                                    {(() => {
                                        const isInvalid = !!touchedCartonNumber[idx] && isCartonNumberInvalid(c);
                                        const errorId = `carton-number-error-${idx}`;
                                        return (
                                            <div className={styles.field}>
                                                <input
                                                    className={`${styles.input} ${isInvalid ? styles.invalid : ''}`}
                                                    value={c.cartonNumber}
                                                    onChange={(e) => handleChange(idx, 'cartonNumber')(e.target.value)}
                                                    onBlur={() => setTouchedCartonNumber(prev => ({ ...prev, [idx]: true }))}
                                                    required
                                                    aria-invalid={isInvalid}
                                                    aria-describedby={isInvalid ? errorId : undefined}
                                                    maxLength={16}
                                                />
                                                {isInvalid && (
                                                    <div id={errorId} className={styles.error}>Required</div>
                                                )}
                                            </div>
                                        );
                                    })()}
                                </td>
                                <td data-label={translate('Length')}>
                                    <DecimalInput
                                        name={`carton-length-${idx}-${c.cartonNumber}`}
                                        value={c.cartonLength ? parseFloat(c.cartonLength.toString()) : null}
                                        min={0}
                                        onChange={e =>
                                            handleChange(idx, 'cartonLength')(e.target.value)
                                        }

                                    />
                                </td>
                                
                                <td data-label={translate('Width')}>
                                    <DecimalInput
                                        name={`carton-width-${idx}-${c.cartonNumber}`}
                                        value={c.cartonWidth ? parseFloat(c.cartonWidth.toString()) : null}
                                        min={0}
                                        onChange={(e) =>
                                            handleChange(idx, 'cartonWidth')(e.target.value)
                                        }

                                    />
                                </td>
                                <td data-label={translate('Height')}>
                                    <DecimalInput
                                        name={`carton-height-${idx}-${c.cartonNumber}`}
                                        value={c.cartonHeight ? parseFloat(c.cartonHeight.toString()) : null}
                                        min={0}
                                        onChange={(e) =>
                                            handleChange(idx, 'cartonHeight')(e.target.value)
                                        }

                                    />
                                </td>
                                <td data-label={translate('Weight')}>
                                    <DecimalInput
                                        name={`carton-weight-${idx}-${c.cartonWeight}`}
                                        value={c.cartonWeight ? parseFloat(c.cartonWeight.toString()) : null}
                                        min={0}
                                        onChange={(e) =>
                                            handleChange(idx, 'cartonWeight')(e.target.value)
                                        }

                                    />
                                </td>
                                <td className={styles.actions}>
                                    <button type="button" className={styles.removeBtn} onClick={() => removeCarton(idx)} aria-label={translate('Remove row')}>×</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <AddButton onClick={addCarton} withContainer>{translate('Add Row')}</AddButton>
        </CardComponent>
    );
};
export default CartonMeasurement;


